import { useState } from 'react';

export type ListState = {
    type: 'list';
};

export type AddState = {
    type: 'add';
};

export type EditState = {
    type: 'edit';
    invoiceItemId: string;
};

export type ClientInvoiceItemsState = ListState | AddState | EditState;

export type UseClientInvoiceItemsStateArgs = {
    onComplete: () => void;
};

export type UseClientInvoiceItemsStateReturnValue = {
    state: ClientInvoiceItemsState;
    onEditInvoiceLineItem: (invoiceItemId: string) => void;
    onEditComplete: () => void;
    onAddInvoiceLineItem: () => void;
    onAddComplete: () => void;
    onCancel: () => void;
    onInvoiceSent: () => void;
};

export const useClientInvoiceItemsState = ({
    onComplete,
}: UseClientInvoiceItemsStateArgs): UseClientInvoiceItemsStateReturnValue => {
    const [state, setState] = useState<ClientInvoiceItemsState>({ type: 'list' });

    const onEditInvoiceLineItem = (invoiceItemId: string) => {
        setState({ type: 'edit', invoiceItemId });
    };

    const onAddInvoiceLineItem = () => {
        setState({ type: 'add' });
    };

    const backToList = () => {
        setState({ type: 'list' });
    };

    return {
        state,
        onEditInvoiceLineItem,
        onEditComplete: backToList,
        onAddInvoiceLineItem,
        onAddComplete: backToList,
        onCancel: backToList,
        onInvoiceSent: onComplete,
    };
};
